import { createElement, FC, ReactNode } from 'react'
import clsx from 'clsx'

interface Props {
  type?: string
  children?: ReactNode
  className?: string
}

const Text: FC<Props> = (props) => {
  let textClass
  let htmlTag
  switch (props.type) {
    case 'above':
      htmlTag = 'p'
      textClass = 'text-above font-bonprix'
      break
    case 'tiny':
      htmlTag = 'p'
      textClass = 'text-tiny font-sans md:whitespace-break-spaces'
      break
    case 'quote-small':
      htmlTag = 'p'
      textClass = 'text-quote-small-m lg:text-quote-small font-sans md:whitespace-break-spaces'
      break
    case 'quote-big':
      htmlTag = 'p'
      textClass = 'text-quote-big-m lg:text-quote-big font-sans md:whitespace-break-spaces'
      break
    case 'intro':
      htmlTag = 'p'
      textClass = 'text-intro-m lg:text-intro font-sans md:whitespace-break-spaces'
      break
    case 'form-label':
      htmlTag = 'p'
      textClass = 'font-sans absolute text-form-label -top-[12px] left-s px-xs bg-white'
      break
    default:
      htmlTag = 'p'
      textClass = 'text-p font-sans md:whitespace-break-spaces'
      break
  }

  return createElement(
    htmlTag,
    { className: clsx(textClass + ' ' + (props.className || '')) },
    props.children
  )
}

export default Text
